import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  EditionsDataProps,
  getActiveEdition,
} from '../../components/navigation/header/primaryHeader/Editions';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { VrLineHeight } from '../../../theming/verticalRhythm/verticalRhythm';
import { AMPSideBarLink } from './AMPSideBarLink';

interface AMPMenuEditionsThemeProps {
    dividerColor: string
    vrLineHeight: VrLineHeight
}

type AMPMenuEditionsProps = AMPMenuEditionsThemeProps & EditionsDataProps;

const createStyle = (dividerColor: string, vrLineHeight:VrLineHeight) => StyleSheet.create({
  divider: {
    backgroundColor: dividerColor,
    height: '1px',
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      margin: `0 ${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      margin: `0 ${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
    },
  },
});

export const AMPMenuEditions:React.FunctionComponent<AMPMenuEditionsProps> = props => {
  const { editions, dividerColor, vrLineHeight, editionEndpoint } = props;
  const activeEdition = getActiveEdition(editions, editionEndpoint);
  const { href, text } = activeEdition;
  const notActivatedEditions = editions.filter(edition => edition.text !== text);
  const style = createStyle(dividerColor, vrLineHeight);
  return (
    <React.Fragment>
      <div className={css(style.divider)} />
      {/*
  // @ts-ignore TS2339: Property 'amp-accordion' does not exist on type 'JSX.IntrinsicElements'. */}
      <amp-accordion id="editions-accordion" disable-session-states={undefined}>
        <AMPSideBarLink href={href} text={text} childrenLinks={notActivatedEditions} />
        {/*
  // @ts-ignore TS2339: Property 'amp-accordion' does not exist on type 'JSX.IntrinsicElements'. */}
      </amp-accordion>
    </React.Fragment>

  );
};
